// extracted by css-extract-rspack-plugin
export default {"documentPreviewContainer":"DocumentPreview_documentPreviewContainer__mt4rT"};